import { render, staticRenderFns } from "./item-child-box.vue?vue&type=template&id=db3c1d7e&scoped=true&"
import script from "./item-child-box.vue?vue&type=script&lang=ts&"
export * from "./item-child-box.vue?vue&type=script&lang=ts&"
import style0 from "./item-child-box.vue?vue&type=style&index=0&id=db3c1d7e&scoped=true&lang=scss&"
import style1 from "./item-child-box.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3c1d7e",
  null
  
)

export default component.exports